import { Loader2 } from 'lucide-react';
import * as React from 'react';

/** Loading, empty and error states (definition of done, handover 01 §6). */
export function Loading({ label = 'Loading…' }: { label?: string }) {
  return <div className="flex items-center gap-2 p-6 text-ink-3" role="status"><Loader2 className="size-4 animate-spin" aria-hidden />{label}</div>;
}
export function Empty({ title, children }: { title: string; children?: React.ReactNode }) {
  return <div className="rounded-xl border border-dashed border-line bg-surface p-8 text-center"><p className="font-semibold text-ink">{title}</p>{children && <div className="mt-1 text-ink-3">{children}</div>}</div>;
}
export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div role="alert" className="rounded-xl border border-bad/20 bg-bad-bg p-6 text-bad">
      <p className="font-semibold">{message}</p>
      {onRetry && <button className="mt-2 font-semibold underline" onClick={onRetry}>Try again</button>}
    </div>
  );
}
